import { render, staticRenderFns } from "./commonApproval.vue?vue&type=template&id=39f6cedc&scoped=true&"
import script from "./commonApproval.vue?vue&type=script&lang=js&"
export * from "./commonApproval.vue?vue&type=script&lang=js&"
import style0 from "./commonApproval.vue?vue&type=style&index=0&id=39f6cedc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f6cedc",
  null
  
)

export default component.exports